<script>
import { mapGetters } from "vuex";
import { onMounted, ref } from "vue";
import AppSidebarCart from "./AppSidebarCart.vue";
export default {
  name: "AppNav",
  components: {
    AppSidebarCart,
  },
  data() {
    return {
      cart: null,
      active: {
        product_cart: false,
      },
      scrollPosition: 0,
      isScrollinUp: false,
    };
  },
  methods: {
    logOut() {
      this.$store.dispatch("logOut").then(() => {
        this.$router.push("/login");
      });
    },
    viewCart() {
      this.active.product_cart = true;
    },
    closeCart() {
      this.active.product_cart = false;
    },
    handleScroll() {
      this.scrollPosition = window.scrollY;
    },
  },
  computed: {
    ...mapGetters(["cartCount"]),
    shouldAnimate() {
      const isScrollingDown =
        this.scrollPosition > 0 &&
        this.scrollPosition > this.previousScrollPosition;
      const shouldAnimate = this.scrollPosition > 100 && isScrollingDown;

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.previousScrollPosition = this.scrollPosition;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.isScrollinUp = !isScrollingDown;

      return shouldAnimate;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  setup() {
    const isMobileNavActive = ref(false);
    const isMenuActive = ref(false);

    const toggleMobileNav = () => {
      isMobileNavActive.value = !isMobileNavActive.value;
      isMenuActive.value = !isMenuActive.value;
    };

    const closeMobileNav = () => {
      if (isMobileNavActive.value) {
        isMobileNavActive.value = false;
        isMenuActive.value = false;
      }
    };

    onMounted(() => {
      window.addEventListener("scroll", closeMobileNav);
    });

    return {
      isMobileNavActive,
      isMenuActive,
      toggleMobileNav,
      closeMobileNav,
    };
  },
};
</script>

<template>
  <marquee width="100%">
    <div>
      <span>Free shipping on all domestic orders over $150</span>
      <span>
        <RouterLink to="/shop">Shop Now</RouterLink>
      </span>
      <span>Free shipping on all international orders over $300</span>
      <span>
        <RouterLink to="/shop">Shop Now</RouterLink>
      </span>
      <span>Free shipping on all domestic orders over $150</span>
      <span>
        <RouterLink to="/shop">Shop Now</RouterLink>
      </span>
      <span>Free shipping on all international orders over $300</span>
      <span>
        <RouterLink to="/shop">Shop Now</RouterLink>
      </span>
    </div>
  </marquee>
  <section
    :class="{
      'header--hidden': shouldAnimate,
      'header--visible': !shouldAnimate,
    }"
  >
    <header>
      <div
        id="mobile-menu"
        @click="toggleMobileNav"
        :class="{ 'is-active': isMenuActive }"
      >
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </div>
      <div class="logo">
        <RouterLink to="/">
          <img alt="" src="@/assets/Logo.png" />
        </RouterLink>
        <RouterLink to="/">
          <h2>Home Décor</h2>
        </RouterLink>
      </div>
      <nav :class="{ 'mobile-nav': isMobileNavActive }">
        <div class="nav-link">
          <RouterLink to="/shop">
            <div class="cta">
              <span class="underline-animation">Shop All</span>
            </div>
          </RouterLink>
          <RouterLink to="/furniture">
            <div class="cta">
              <span class="underline-animation">Furniture</span>
            </div>
          </RouterLink>
          <RouterLink to="/lighting">
            <div class="cta">
              <span class="underline-animation">Lighting</span>
            </div>
          </RouterLink>
          <RouterLink to="/rug">
            <div class="cta">
              <span class="underline-animation">Rug</span>
            </div>
          </RouterLink>
          <RouterLink to="/about">
            <div class="cta">
              <span class="underline-animation">About Us</span>
            </div>
          </RouterLink>
          <ul class="wrapper-icon">
            <li class="icon facebook">
              <a href="https://www.facebook.com/" target="_blank">
                <font-awesome-icon :icon="['fab', 'facebook-f']" />
              </a>
            </li>
            <li class="icon twitter">
              <a href="https://twitter.com/" target="_black">
                <font-awesome-icon :icon="['fab', 'twitter']" />
              </a>
            </li>
            <li class="icon instagram">
              <a href="https://www.instagram.com/" target="_blank">
                <font-awesome-icon :icon="['fab', 'instagram']" />
              </a>
            </li>
          </ul>
        </div>
        <div
          class="menu-toggle"
          @click="closeMobileNav"
          :class="{
            'mobile-nav': isMobileNavActive,
            'is-active': isMenuActive,
          }"
        >
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </div>
      </nav>
      <div class="icons">
        <div class="search">
          <button>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25px"
              height="25px"
              viewBox="0 0 24 24"
              id="search"
            >
              <path
                fill="#000000"
                d="M21.8594971,21.1526489l-4.1618652-4.1618652C19.1226807,15.3989258,19.9974976,13.3041992,20,11c0-4.9705811-4.0294189-9-9-9s-9,4.0294189-9,9s4.0294189,9,9,9c2.3041382-0.0025024,4.3988647-0.8771973,5.9906616-2.3021851l4.1618042,4.1618042c0.1937866,0.1871948,0.5009766,0.1871948,0.6947632,0C22.0458374,21.6677856,22.0513306,21.3512573,21.8594971,21.1526489z M11,19c-4.4182739,0-8-3.5817261-8-8s3.5817261-8,8-8c4.4161987,0.0050659,7.9949341,3.5838013,8,8C19,15.4182739,15.4182739,19,11,19z"
              ></path>
            </svg>
          </button>
          <div class="search-input">
            <input type="text" placeholder="Search" />
          </div>
        </div>
        <div>
          <button @click="viewCart">
            <div>
              <p class="count" v-if="cartCount">{{ cartCount }}</p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="25px"
                height="25px"
                id="shopping-bag"
              >
                <path
                  fill="#000000"
                  d="M19.5,7H16V5.9169922c0-2.2091064-1.7908325-4-4-4s-4,1.7908936-4,4V7H4.5C4.4998169,7,4.4996338,7,4.4993896,7C4.2234497,7.0001831,3.9998169,7.223999,4,7.5V19c0.0018311,1.6561279,1.3438721,2.9981689,3,3h10c1.6561279-0.0018311,2.9981689-1.3438721,3-3V7.5c0-0.0001831,0-0.0003662,0-0.0006104C19.9998169,7.2234497,19.776001,6.9998169,19.5,7z M9,5.9169922c0-1.6568604,1.3431396-3,3-3s3,1.3431396,3,3V7H9V5.9169922z M19,19c-0.0014038,1.1040039-0.8959961,1.9985962-2,2H7c-1.1040039-0.0014038-1.9985962-0.8959961-2-2V8h3v2.5C8,10.776123,8.223877,11,8.5,11S9,10.776123,9,10.5V8h6v2.5c0,0.0001831,0,0.0003662,0,0.0005493C15.0001831,10.7765503,15.223999,11.0001831,15.5,11c0.0001831,0,0.0003662,0,0.0006104,0C15.7765503,10.9998169,16.0001831,10.776001,16,10.5V8h3V19z"
                ></path>
              </svg>
            </div>
          </button>
        </div>
      </div>
      <div class="cart-icon">
        <button @click="viewCart">
          <div>
            <p class="count" v-if="cartCount">{{ cartCount }}</p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="25px"
              height="25px"
              id="shopping-bag"
            >
              <path
                fill="#000000"
                d="M19.5,7H16V5.9169922c0-2.2091064-1.7908325-4-4-4s-4,1.7908936-4,4V7H4.5C4.4998169,7,4.4996338,7,4.4993896,7C4.2234497,7.0001831,3.9998169,7.223999,4,7.5V19c0.0018311,1.6561279,1.3438721,2.9981689,3,3h10c1.6561279-0.0018311,2.9981689-1.3438721,3-3V7.5c0-0.0001831,0-0.0003662,0-0.0006104C19.9998169,7.2234497,19.776001,6.9998169,19.5,7z M9,5.9169922c0-1.6568604,1.3431396-3,3-3s3,1.3431396,3,3V7H9V5.9169922z M19,19c-0.0014038,1.1040039-0.8959961,1.9985962-2,2H7c-1.1040039-0.0014038-1.9985962-0.8959961-2-2V8h3v2.5C8,10.776123,8.223877,11,8.5,11S9,10.776123,9,10.5V8h6v2.5c0,0.0001831,0,0.0003662,0,0.0005493C15.0001831,10.7765503,15.223999,11.0001831,15.5,11c0.0001831,0,0.0003662,0,0.0006104,0C15.7765503,10.9998169,16.0001831,10.776001,16,10.5V8h3V19z"
              ></path>
            </svg>
          </div>
        </button>
      </div>
    </header>
    <hr />
    <div class="icon-wrapper">
      <ul class="wrapper">
        <li class="icon facebook">
          <a href="https://www.facebook.com/" target="_blank">
            <font-awesome-icon :icon="['fab', 'facebook-f']" />
          </a>
        </li>
        <li class="icon twitter">
          <a href="https://twitter.com/" target="_black">
            <font-awesome-icon :icon="['fab', 'twitter']" />
          </a>
        </li>
        <li class="icon instagram">
          <a href="https://www.instagram.com/" target="_blank">
            <font-awesome-icon :icon="['fab', 'instagram']" />
          </a>
        </li>
      </ul>
    </div>
  </section>
  <div class="side-cart">
    <AppSidebarCart
      :active="active.product_cart"
      @close-product-cart="closeCart"
    />
  </div>
</template>

<style lang="scss" scoped>
marquee {
  font-family: Poppins;
  font-weight: 500;
  font-size: 15px;
  line-height: 21px;
  width: calc(100% + 44px);
  color: #fff;
  background-color: #000;
  text-decoration: none;
  padding: 6px 0;

  span:before {
    display: inline-block;
    content: "";
    border-radius: 50%;
    width: 10px;
    height: 10px;
    position: relative;
    top: -1px;
    vertical-align: baseline;
    background-color: #000;
    margin: 0 16px;
  }

  a {
    text-decoration: none;
    color: #fff;
    font-size: 20px;
  }
}

section {
  z-index: 1;
  position: sticky;
  top: 0;
  background-color: #fff;
  width: 100%;
}

.header--hidden {
  transform: translateY(-100%);
  animation: slide-up 0.7s forwards;
  @keyframes slide-up {
    0% {
      transform: translateY(0%);
    }
    100% {
      transform: translateY(-100%);
    }
  }
}
.header--visible {
  transform: translateY(0%);
  animation: slide-down 0.7s backwards;
  @keyframes slide-down {
    0% {
      transform: translateY(-100%);
    }
    100% {
      transform: translateY(0%);
    }
  }
}

.header {
  transition: transform 0.5s;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 50px;
  padding: 0 50px;
  height: 80px;
  flex-grow: 1;

  .logo {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    position: relative;

    img {
      width: 90px;
      object-fit: contain;
      aspect-ratio: 4/3;
      border-radius: 100%;
    }

    h2 {
      font-family: Poppins;
      font-style: normal;
      font-weight: 500;
    }

    a {
      text-decoration: none;
      color: #000;
    }
  }

  #mobile-menu {
    justify-self: start;
    display: none;

    .bar {
      height: 2px;
      background-color: #000;
      margin: 5px auto;
      transition: all 0.6s ease-in;

      &:first-child,
      &:last-child {
        width: 15px;
      }

      &:nth-child(2) {
        width: 24px;
      }
    }
  }

  #mobile-menu.is-active {
    opacity: 0;
    transition: 0.3s;
  }

  .mobile-nav {
    .bar:nth-child(2) {
      opacity: 0;
    }

    .bar:nth-child(1) {
      transform: translateY(12px) rotate(45deg);
      -webkit-transform: translateY(12px) rotate(45deg);
      -o-transform: translateY(12px) rotate(45deg);
      -ms-transform: translateY(12px) rotate(45deg);
      width: 24px;
      opacity: 0.7;
      height: 2px;
      background-color: #000;
    }

    .bar:nth-child(3) {
      transform: translateY(10px) rotate(-45deg);
      -webkit-transform: translateY(10px) rotate(-45deg);
      -o-transform: translateY(10px) rotate(-45deg);
      -ms-transform: translateY(10px) rotate(-45deg);
      width: 24px;
      opacity: 0.7;
      height: 2px;
      background-color: #000;
    }
  }

  nav {
    display: flex;
    flex-direction: row;

    .nav-link {
      display: flex;
      gap: 2rem;

      .cta:hover .underline-animation:after {
        transform: scaleX(1);
        transform-origin: bottom left;
      }

      .underline-animation {
        position: relative;
        padding-bottom: 2px;
        color: #000;

        &:after {
          content: "";
          position: absolute;
          width: 100%;
          transform: scaleX(0);
          height: 1px;
          bottom: 0;
          left: 0;
          background-color: rgba($color: #000000, $alpha: 0.5);
          transform-origin: bottom right;
          transition: transform 0.25s ease-out;
        }
      }

      a {
        font-family: Poppins;
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 21px;
        text-decoration: none;
      }
    }

    .wrapper-icon {
      display: none;
    }
  }

  .icons {
    display: flex;
    gap: 1rem;

    .close-cart {
      transform: translate(0%);
    }

    .search {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      width: 100%;
      height: 100%;
      border: 1px solid rgba($color: #000, $alpha: 0.2);
      background-color: rgba($color: #929292, $alpha: 0.2);
      border-radius: 50px;

      input {
        border: none;
        background-color: transparent;
        padding: 0 10px;
        font-family: Poppins;
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 21px;

        &:focus {
          outline: none;
        }
      }
    }

    .count {
      position: absolute;
      border-radius: 1000px;
      color: #000;
      font-size: 1rem;
      padding: 3px;
      right: 45px;
      top: 0px;
      width: 25px;
      text-align: end;
      height: 25px;
      font-weight: bold;
    }

    button {
      width: 50px;
      height: 50px;

      svg {
        :not(:last-child) {
          margin-right: 20px;
        }

        display: flex;
        align-items: center;
        margin: 0 auto;
      }

      // &:hover {
      //   border-radius: 50%;
      //   background-color: rgba($color: #9c9c9c, $alpha: 0.1);
      // }
    }
  }

  .cart-icon {
    display: none;
  }

  .side-cart {
    display: block;
  }
}

.icon-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 50px;

  .wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;

    .icon {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s;

      svg {
        width: 20px;
        height: 20px;
      }

      &:hover {
        transform: scale(0.95);
      }

      a {
        color: #000;
      }
    }
  }
}

hr {
  width: 95%;
  margin: 0 auto;
}

@media screen and (max-width: 768px) {
  marquee {
    width: 100%;
  }

  header {
    display: flex;
    height: auto;
    line-height: 0;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    z-index: 1000;
    height: 70px;

    .logo {
      margin: 0 auto;
      position: relative;

      img {
        width: 80px;
      }

      h2 {
        display: none;
      }
    }

    #mobile-menu,
    .bar {
      display: block;
      transition: 1s ease;
    }

    .mobile-nav {
      transform: translate(0%) !important;
    }

    nav {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: 1fr;
      left: 0;
      bottom: 0;
      z-index: 200;
      top: 0;
      width: 100%;
      height: 100vh;
      position: absolute;
      justify-content: start;
      align-items: start;
      // height: calc(50vh - 70px);
      transform: translate(-100%);
      overflow: hidden;
      margin: 0;
      background-color: rgba($color: #fff, $alpha: 0.5);
      transition: 0.9s ease;
      font-family: Poppins;

      .nav-link {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: 2rem;
        margin: 0 20px;

        .wrapper-icon {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          list-style: none;
          gap: 10px;

          a {
            color: #000;
          }
        }

        a {
          font-family: Poppins;
          font-style: normal;
          font-weight: 500;
          font-size: 15px;
          line-height: 21px;
          color: #000000;
          text-decoration: none;
          gap: 10px;
        }
      }

      .menu-toggle {
        position: absolute;
        top: 0;
        right: 0;
        margin-right: 20px;
        width: 30px;
        height: 30px;
        background: transparent;
        border: none;
        outline: none;
        cursor: pointer;
        z-index: 1000;
      }
    }

    .icons {
      display: none;
    }

    .cart-icon {
      display: block;

      .login {
        padding-right: 20px;
      }

      .count {
        position: absolute;
        border-radius: 1000px;
        color: #000;
        font-size: 1rem;
        padding: 3px;
        right: 35px;
        width: 25px;
        text-align: end;
        height: 25px;
        font-weight: bold;
      }
    }
  }

  hr {
    margin: 10px auto;
  }

  .icon-wrapper {
    display: none;
  }
}
</style>
